import { Action } from '@ngrx/store';

interface FilterOptions {
  deletedAt: boolean;
  type: 'minimal';
  condition: any;
  valueCondition: number;
}

export enum FilterActionTypes {
  AddAdvancedFilter = '[Filter] Add advanced filter',
  RemoveAdvancedFilter = '[Filter] Remove advanced filter',
  Reset = '[Filter] Reset',

  AddFilterArticleGroup = '[Filter] Add filter article group',
  RemoveFilterArticleGroup = '[Filter] Remove filter article group'
}

export class AddAdvancedFilter implements Action {
  readonly type = FilterActionTypes.AddAdvancedFilter;
  constructor(public filter: any) {}
}

// export class AddAdvancedFilterPro implements Action {
//   readonly type = FilterActionTypes.AddAdvancedFilterPro;
//   constructor(public filter: any) {}
// }

export class RemoveAdvancedFilter implements Action {
  readonly type = FilterActionTypes.RemoveAdvancedFilter;
  constructor(public filter: any) {}
}

export class Reset implements Action {
  readonly type = FilterActionTypes.Reset;
  constructor() {}
}

export class AddFilterArticleGroup implements Action {
  readonly type = FilterActionTypes.AddFilterArticleGroup;
  constructor(public dataFilter: any) {}
}

export class RemoveFilterArticleGroup implements Action {
  readonly type = FilterActionTypes.RemoveFilterArticleGroup;
  constructor(public dataFilter: any) {}
}

export type FilterActionsUnion =
  | AddAdvancedFilter
  | RemoveAdvancedFilter
  | Reset
  | AddFilterArticleGroup
  | RemoveFilterArticleGroup;
